var exports = {
  "zr": "root__b8uJlg",
  "Ji": "canvas__sXjEv7",
  "Om": "dot__YGrZLB",
  "EU": "staticDot__V6p83V",
};

module.exports = exports;
